import {APP_INITIALIZER, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutComponent } from './layout/layout.component';
import { HeaderNewComponent } from './layout/headernew/headernew.component';
import { FooterNewComponent } from './layout/footernew/footernew.component';
import { ContentComponent } from './layout/content/content.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { SearchPageComponent } from './pages/search-page/search-page.component';
import { ResultsPageComponent } from './pages/results-page/results-page.component';
import { DetailsPageComponent } from './pages/details-page/details-page.component';
import {ApiService} from "./services/api/api.service";
import {ConfigService} from "./services/config/config.service";
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import { SearchInputComponent } from './components/search-input/search-input.component';
import { FormaDosaggioComponent } from './components/forma-dosaggio/forma-dosaggio.component';
import { FiltriComponent } from './components/filtri/filtri.component';
import { SingleFilterComponent } from './components/single-filter/single-filter.component';
import { ConfezioneComponent } from './components/confezione/confezione.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import {SpinnerService} from "./services/spinner/spinner.service";
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
//import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import { DownloadPageComponent } from './pages/download-page/download-page.component';
import {CookieService} from "ngx-cookie-service";
import {APP_BASE_HREF, PlatformLocation} from "@angular/common";
import { GlossaryPageComponent } from './pages/glossary-page/glossary-page.component';
import { StatsItemComponent } from './stats-item/stats-item.component';
import { ButtonSectionComponent } from './pages/button-section/button-section.component';
import { SvgIconComponent } from './svg-icon/svg-icon.component';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { AlphabetSelectorComponent } from './components/alphabet-selector/alphabet-selector.component';
import { GlossaryEntryComponent } from './components/glossary-entry/glossary-entry.component';
import { StaticTextComponent } from './static-text/static-text.component';
import { InfoAifaPageComponent } from './pages/info-aifa-page/info-aifa-page.component';
import { HeadersInterceptor } from './services/api/interceptors/headers.interceptor';
import { SearchbarComponent } from './pages/results-page/searchbar/searchbar.component';
import { ModalComponent } from './components/modal/modal.component';

//Librerie Material
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import {MatExpansionModule} from '@angular/material/expansion';
import { ToptenComponent } from './layout/topten/topten.component';
import { CleanCharsPipe } from "./pipes/cleanchars.pipe";
import { PlatformModule } from '@angular/cdk/platform';
// import { AnalyticsService } from './services/tracker/analytics.service';

export function initConfig(appConfig: ConfigService) {
  return () => new Promise((resolve, reject) => {
    appConfig.loadConfig(resolve, reject)
  })
}
@NgModule({
    declarations: [
        AppComponent,
        LayoutComponent,
        HeaderNewComponent,
        FooterNewComponent,
        ContentComponent,
        SearchPageComponent,
        ResultsPageComponent,
        DetailsPageComponent,
        NotFoundPageComponent,
        SearchInputComponent,
        FormaDosaggioComponent,
        FiltriComponent,
        SingleFilterComponent,
        ConfezioneComponent,
        SpinnerComponent,
        //LanguageSelectorComponent,
        DownloadPageComponent,
        GlossaryPageComponent,
        StatsItemComponent,
        ButtonSectionComponent,
        SvgIconComponent,
        BreadcrumbsComponent,
        AlphabetSelectorComponent,
        GlossaryEntryComponent,
        StaticTextComponent,
        InfoAifaPageComponent,
        SearchbarComponent,
        ModalComponent,
        ToptenComponent
    ],
    providers: [
        // AnalyticsService,
        ApiService,
        {
            provide: APP_INITIALIZER,
            useFactory: initConfig,
            deps: [ConfigService],
            multi: true,
        },
        SpinnerService,
        CookieService,
        {
            provide: APP_BASE_HREF,
            useFactory: (s: PlatformLocation) => s.getBaseHrefFromDOM(),
            deps: [PlatformLocation]
        },
        {
            provide: HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true
        }
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        NoopAnimationsModule,
        ReactiveFormsModule,
        HttpClientModule,
        InfiniteScrollModule,
        FormsModule,
        PlatformModule,
        MatAutocompleteModule,
        MatTooltipModule,
        MatButtonModule,
        MatExpansionModule,
        CleanCharsPipe
    ]
})
export class AppModule { }
